import SideBar from '@components/layouts/private/user/components/SideBar'
import About from '@pages/user/aboutus/About'
import PrivacyPolicy from '@pages/user/aboutus/PrivacyPolicy'
import RefundPolicy from '@pages/user/aboutus/RefundPolicy'
import Support from '@pages/user/aboutus/Support'
import TermsCondition from '@pages/user/aboutus/TermsCondition'
import BookDesc from '@pages/user/allPages/BookDesc'
import ChangePassword from '@pages/user/allPages/ChangePassword'
import CreateBook from '@pages/user/allPages/CreateBook'
import ManageProfile from '@pages/user/allPages/ManageProfile'
import ViewMyBooks from '@pages/user/allPages/viewBook'
import BookListing from '@pages/user/bookListing'
import History from '@pages/user/history'
import NotificationPage from '@pages/user/notification'
import SubscriptionPage from '@pages/user/subsciption'

const userRoutes = [
  {
    Component: ManageProfile,
    exact: true,
    path: 'manage-profile',
  },
  {
    Component: ChangePassword,
    path: 'change-password',
  },
  {
    Component: CreateBook,
    path: 'create-book',
  },
  {
    Component: CreateBook,
    path: 'update-book/:id',
  },
  {
    Component: SideBar,
    path: 'account',
  },
  {
    Component: SubscriptionPage,
    path: 'subscription',
  },
  {
    Component: SubscriptionPage,
    path: 'subscription/payment-status',
  },
  {
    Component: BookDesc,
    path: ':name/:id',
  },
  {
    Component: History,
    exact: true,
    path: 'history',
  },
  {
    Component: BookListing,
    path: 'my-books',
  },
  {
    Component: ViewMyBooks,
    path: 'my-books/:name/:id',
  },
  {
    Component: About,
    path: 'about-us',
  },
  {
    Component: PrivacyPolicy,
    path: 'privacy-policy',
  },
  {
    Component: TermsCondition,
    path: 'terms-and-condition',
  },
  {
    Component: RefundPolicy,
    path: 'refund-policy',
  },
  {
    Component: Support,
    path: 'support',
  },
  {
    Component: NotificationPage,
    path: 'notification',
  },
]

export default userRoutes
